export default __webpack_public_path__ + "media/flavours/glitch/images/mbstobon-ui-0-07a1d75b024f0b0aed7127e1c1b20fc2.png";